import React, { Component, Fragment } from "react";
import CustomSpinner from '../../components/CustomSpinner/CustomSpinner';
import {
  Collapse,
  Table,
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap";
import "./About.css";
import classnames from "classnames";
import * as Scroll from "react-scroll";
import AuthService from "../../services/AuthService";
import AboutService from "../../services/AboutService";
import UserService from "../../services/UserService";
export default class About extends Component {

  state = {
    showTextAbout: false,
    showTextEnroll: false,
    showTextPointsEarn: false,
    showTermsAndConditions: false,
    activeTab: "1",
    showMore: true,
    transform: true,
    showInkBar: true,
    selectedTabKey: 0,
    transformWidth: 400,
    aboutData: null,
    selectedYearData: '',
    isLoading: false
  };
  isMobile = false;
  isLogin = false;
  isShowMore = true;
  pcrType = "multibrand";

  constructor(props) {
    super(props);
    this.state = {
      activeCategory: "PCR",
      activeTab: this.props.secondary ? "2" : "1",
      showMore: true,
      transform: true,
      showInkBar: true,
      selectedTabKey: 0,
      transformWidth: 400
    };
    if (this.props.pcrType) {
      this.pcrType = this.props.pcrType;
    }
    this.toggle = this.toggle.bind(this);
    //  this.getAboutDetail();
    if (AuthService.isAuthenticated()) {
      this.getUserDetail();
    }
  }

  componentDidMount() {
    this.checkUserAgent();
    this.getAboutDetail();
    this.isLogin = AuthService.isAuthenticated();
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  getUserDetail() {
    UserService.getUserInfo()
      .then(response => {
        if (
          response.data &&
          response.data.data &&
          response.data.data.dealer_type
        ) {
          this.pcrType = response.data.data.dealer_type;
        }
        //let userData = response.data.data;
      })
      .catch(e => {
        console.error("e", e);
      });
  }

  getAboutDetail = async () => {
    try {
      this.setState({ isLoading: true })
      const { data } = await AboutService.getAboutDetails();
      if (data) {
        this.allData = data.data;

        // this.allData = {
        //   "years": [
        //     {
        //       "key": "2023-24",
        //       "value": "2023-24",
        //       "selected": true
        //     },
        //     {
        //       "key": "2024-25",
        //       "value": "2024-25",
        //       "selected": false
        //     },
        //     {
        //       "key": "2025-26",
        //       "value": "2025-26",
        //       "selected": false,
        //     },
        //   ],
        //   "2019-20": {
        //     "aboutTheProgram": "JK Baadshah is a point based Customer Relationship Program for fleets buying JK Truck/Bus Radial & Bias Tyres.",
        //     "aboutPoints": [
        //       "There will be 3 offtake slabs under which each member will be classified and earn points.",
        //       "Direct and Indirect Fleets will be enrolled in the program.",
        //       "Member will earn points both on JK branded TBR/TBB product purchase.",
        //       "Member will also earn points if he avails services at JK Treads or buy Motul products.",
        //       "Exciting Loyalty Bonus and much more to build strong engagement.",
        //       "Direct communication from the brand in terms of products updates, newsletters, soft benefits and much more."
        //     ],
        //     "enrollmentToTheProgram": [
        //       "Any fleet with a minimum potential of 300 Truck/Buses tyres (annual) can be enrolled into the program. If potential is less than 300, billing mode should be direct.",
        //       "Fleet will be entitled to fill in the complete enrolment form with the help of JK FM personal to get enrolled into the program. Enrolment form is available online.",
        //       "Submission of the Fleet GST Number at the time of enrolment is mandatory and will be verified from the backend.",
        //       "Once the fleet is enrolled and details are verified, the fleet will be sent his membership details like log-in ID, password to CRM website, mobile App and communication to his registered address."
        //     ],
        //     "pointsEarning": [
        //       "There are three slabs available based on the offtake of TBR tyres through out the year.",
        //       "The member will have the benefit of earning points on purchase of both TBR & TBB tyres of JK brand"
        //     ],
        //     "pointStructure": [
        //       {
        //         "pointsRange": [
        //           "< 75 TBR Tyres"
        //         ],
        //         "image": "images/prince.svg",
        //         "type": "Offtake Slab 1"
        //       },
        //       {
        //         "pointsRange": [
        //           "75-500 TBR Tyres"
        //         ],
        //         "type": "Offtake Slab 2",
        //         "image": "images/king.svg"
        //       },
        //       {
        //         "type": "Offtake Slab 3",
        //         "pointsRange": [
        //           "> 500 TBR Tyres"
        //         ],
        //         "image": "images/emperor.svg"
        //       }
        //     ],
        //     "allCategoryPoints": {
        //       "headers": [
        //         "TBR Offtake Slab",
        //         "TBR Points/Tyre",
        //         "TBB Points/Tyre"
        //       ],
        //       "points": [
        //         [
        //           "<75",
        //           "50",
        //           30
        //         ],
        //         [
        //           "75 to 500",
        //           "100",
        //           75
        //         ],
        //         [
        //           ">500",
        //           "150",
        //           100
        //         ]
        //       ]
        //     },
        //     "fleetClub": "",
        //     "pointsEarnRulesHeaders": [
        //       "Sr No",
        //       "Yearly Offtake",
        //       "Slab Applicable",
        //       "Points Per Tyre",
        //       "Points",
        //       "Total Points",
        //       "TBR",
        //       "TBB",
        //       "Slab Jump Points"
        //     ],
        //     "pointsEarnRulesHeading": {
        //       "heading1": [
        //         {
        //           "keyName": "srNo",
        //           "labelName": "Sr No",
        //           "rowSpan": 2,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "yearlyOfftake",
        //           "labelName": "Yearly Offtake",
        //           "rowSpan": null,
        //           "colSpan": 2
        //         },
        //         {
        //           "keyName": "slabApplicable",
        //           "labelName": "Slab Applicable",
        //           "rowSpan": 2,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "pointPerTyre",
        //           "labelName": "Points per Tyre",
        //           "rowSpan": null,
        //           "colSpan": 2
        //         },
        //         {
        //           "keyName": "points",
        //           "labelName": "Points",
        //           "rowSpan": null,
        //           "colSpan": 2
        //         },
        //         {
        //           "keyName": "totalPoints",
        //           "labelName": "Total Points",
        //           "rowSpan": 2,
        //           "colSpan": null
        //         }
        //       ],
        //       "heading2": [
        //         {
        //           "keyName": "yearlyOfftakeTbr",
        //           "labelName": "TBR",
        //           "rowSpan": null,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "yearlyOfftakeTbb",
        //           "labelName": "TBB",
        //           "rowSpan": null,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "pointPerTyreTbr",
        //           "labelName": "TBR",
        //           "rowSpan": null,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "pointPerTyreTbb",
        //           "labelName": "TBB",
        //           "rowSpan": null,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "pointsTbr",
        //           "labelName": "TBR",
        //           "rowSpan": null,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "pointsTbb",
        //           "labelName": "TBB",
        //           "rowSpan": null,
        //           "colSpan": null
        //         }
        //       ]
        //     },
        //     "pointsEarnRules": {
        //       "headingLable": [
        //         {
        //           "keyName": "srNo"
        //         },
        //         {
        //           "keyName": "yearlyOfftakeTbr"
        //         },
        //         {
        //           "keyName": "yearlyOfftakeTbb"
        //         },
        //         {
        //           "keyName": "slabApplicable"
        //         },
        //         {
        //           "keyName": "pointPerTyreTbr"
        //         },
        //         {
        //           "keyName": "pointPerTyreTbb"
        //         },
        //         {
        //           "keyName": "pointsTbr"
        //         },
        //         {
        //           "keyName": "pointsTbb"
        //         },
        //         {
        //           "keyName": "totalPoints"
        //         }
        //       ],
        //       "data": [
        //         {
        //           "srNo": "1",
        //           "yearlyOfftakeTbr": "2000",
        //           "yearlyOfftakeTbb": "3000",
        //           "slabApplicable": ">500",
        //           "pointPerTyreTbr": "150",
        //           "pointPerTyreTbb": "100",
        //           "pointsTbr": "30000",
        //           "pointsTbb": "30000",
        //           "totalPoints": "600000"
        //         },
        //         {
        //           "srNo": "2",
        //           "yearlyOfftakeTbr": "250",
        //           "yearlyOfftakeTbb": "1000",
        //           "slabApplicable": "75 to 500",
        //           "pointPerTyreTbr": "100",
        //           "pointPerTyreTbb": "75",
        //           "pointsTbr": "25000",
        //           "pointsTbb": "75000",
        //           "totalPoints": "100000"
        //         },
        //         {
        //           "srNo": "3",
        //           "yearlyOfftakeTbr": "50",
        //           "yearlyOfftakeTbb": "800",
        //           "slabApplicable": "<75",
        //           "pointPerTyreTbr": "50",
        //           "pointPerTyreTbb": "30",
        //           "pointsTbr": "2500",
        //           "pointsTbb": "24000",
        //           "totalPoints": "26500"
        //         },
        //         {
        //           "srNo": "4",
        //           "yearlyOfftakeTbr": "0",
        //           "yearlyOfftakeTbb": "2500",
        //           "slabApplicable": "<75",
        //           "pointPerTyreTbr": "50",
        //           "pointPerTyreTbb": "30",
        //           "pointsTbr": "0",
        //           "pointsTbb": "75000",
        //           "totalPoints": "75000"
        //         },
        //         {
        //           "srNo": "5",
        //           "yearlyOfftakeTbr": "2500",
        //           "yearlyOfftakeTbb": "0",
        //           "slabApplicable": ">500",
        //           "pointPerTyreTbr": "150",
        //           "pointPerTyreTbb": "100",
        //           "pointsTbr": "375000",
        //           "pointsTbb": "0",
        //           "totalPoints": "375000"
        //         }
        //       ]
        //     },
        //     "termsAndCondtions": {
        //       "title": "General Terms",
        //       "data": [
        //         "Enrolment to this program is by invitation and JK Tyre & Industries Ltd. holds the sole discretion of selecting the fleets to be enrolled.",
        //         "This program is valid from 1st April-2019 to 31st March, 2020.",
        //         "This program is available for authorized and selected fleets of JK Tyre in India and Bhutan.",
        //         "Points or Rewards of the Gift Catalogue cannot be exchanged, transferred or redeemed for cash or credit note.",
        //         "Once redemption is announced points can be redeemed for an amount equivalent to or less than the points accumulated at the time of redemption request.",
        //         "Computation of points by JK Tyre & Industries Ltd. will be final, conclusive and binding on the fleets and will not be called in disputed except in case of manifest, bona fide or inadvertent error.",
        //         "JK Tyre & Industries Ltd. does not have any obligation to reveal the value of points and rewards to the fleets, JK Tyre holds the decision to change the product as per the availability and price escalation.",
        //         "Redeemed points will be adjusted against the ex-showroom price of the vehicle redeemed. Any charges towards registration, insurance, road taxes, accessories incurring additional charges over ex-showroom costs will be borne by the fleet.",
        //         "Images shown in the redemption catalogue are representative and the actual product features may vary at the discretion of the manufacturer / marketer at the time the order is placed.",
        //         "JK Tyre & Industries Ltd. has a right to verify any/all sales made during the scheme period in whatever way it seems fit.",
        //         "Computation of points by JK Tyre & Industries Ltd. will be final, conclusive and binding on the fleets and will not be called in disputed except in case of manifest, bona fide or inadvertent error."
        //       ]
        //     }
        //   },
        //   "2023-24": {
        //     "aboutTheProgram": "The JK Baadshah is a flagship Customer Relationship Program for fleet customers buying JK Truck/Bus Radial and Bias Tyres directly from the company. The program is relaunched for FY 2023-24 with an aim to reward fleet customers who are high performers and acknowledges their effort. It also simplifies the communication exchange between the fleet customers and JK Tyre. The whole motive is to build long term relationships and partnerships. JK Baadshah is the only loyalty program which is offered to the fleet customers across the industry, and today is considered as one of the biggest program.",
        //     "aboutPoints": [
        //       "There will be 5 club categories under which each member will be classified and rewarded.",
        //       "For the ease of access, this program is available on JK Baadshah web portal and mobile app where fleet can check their points, build profile, add subsidiaries and redeem points against the attractive gifts.",
        //       "Apart from Loyalty Reward, this program is a communication tool between fleets and JK Tyres and keep informing and updating fleets on various new products, customer friendly warranty policies , schemes, news alerts pertaining to the industry."
        //     ],
        //     "enrollmentToTheProgram": [],
        //     "pointsEarning": [
        //       "Fleets can earn points against their JK Tyre Truck Bias and Radial offtake as per the point structure only direct purchase from the company will be taken into consideration while calculating the points.",
        //       "Fleet club will be decided by JK Tyre as per the policy in the beginning of the financial year and will remain same for the entire financial year.",
        //       "Sales will be taken from the SAP for each fleet.",
        //       "Claim Tyres will be debited from the offtake for that month. Points will be calculated on a daily basis and slab will be calculated on quarterly basis.",
        //       "Slab jump bonus will be extra and applicable as per the quarterly slab.",
        //       "Entire point earning system is automated and points will be reflected on JK Baadshah portal and mobile App.",
        //       "To login to web portal, visit https://baadshah.jktyrecrm.in or download mobile App JK Baadshah from Google Play Store or Apple App Store. JK Tyre holds to cancel fleet points at any given point in case any discrepancy comes across.",
        //       "JK Tyre has the right to restructure the fleet clubs and points in case of any discrepancy."
        //     ],
        //     "pointStructure": [],
        //     "allCategoryPoints": {
        //       "headers": [
        //         "Club",
        //         "Minimum Quarterly Offtake",
        //         "TBB points per Tyre",
        //         "TBR points per Tyre",
        //         "Slab Jump Bonus Points"
        //       ],
        //       "points": [
        //         [
        //           "Blue Club",
        //           "30",
        //           "150",
        //           "250",
        //           "3000"
        //         ],
        //         [
        //           "Gold Club",
        //           "60",
        //           "175",
        //           "300",
        //           "5000"
        //         ],
        //         [
        //           "Diamond Club",
        //           "90",
        //           "200",
        //           "350",
        //           "11000"
        //         ],
        //         [
        //           "Platinum Club",
        //           "180",
        //           "250",
        //           "400",
        //           "23000"
        //         ],
        //         [
        //           "Chairman's Club",
        //           "360",
        //           "300",
        //           "450",
        //           "25000*"
        //         ]
        //       ],
        //       "chairmanClubNote": "*Chairman's Club Slab jump bonus points will be given on achieving min quarterly offtake in any quarter."
        //     },
        //     "fleetClub": " Gold Club",
        //     "pointsEarnRulesHeading": {
        //       "heading1": [
        //         {
        //           "keyName": "srNo",
        //           "labelName": "Sr No",
        //           "rowSpan": 2,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "quarterlyOfftake",
        //           "labelName": "Quarterly Offtake",
        //           "rowSpan": null,
        //           "colSpan": 2
        //         },
        //         {
        //           "keyName": "minimumOfftakeRequired",
        //           "labelName": "Minimum Offtake required",
        //           "rowSpan": 2,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "pointPerTyre",
        //           "labelName": "Points per Tyre",
        //           "rowSpan": null,
        //           "colSpan": 2
        //         },
        //         {
        //           "keyName": "points",
        //           "labelName": "Points",
        //           "rowSpan": null,
        //           "colSpan": 3
        //         },
        //         {
        //           "keyName": "totalPoints",
        //           "labelName": "Total Points",
        //           "rowSpan": 2,
        //           "colSpan": null
        //         }
        //       ],
        //       "heading2": [
        //         {
        //           "keyName": "quarterlyOfftakeTbb",
        //           "labelName": "TBB",
        //           "rowSpan": null,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "quarterlyOfftakeTbr",
        //           "labelName": "TBR",
        //           "rowSpan": null,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "pointPerTyreTbb",
        //           "labelName": "TBB",
        //           "rowSpan": null,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "pointPerTyreTbr",
        //           "labelName": "TBR",
        //           "rowSpan": null,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "pointsTbb",
        //           "labelName": "TBB",
        //           "rowSpan": null,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "pointsTbr",
        //           "labelName": "TBR",
        //           "rowSpan": null,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "pointsSlabJumpPoints",
        //           "labelName": "Slab Jump Points",
        //           "rowSpan": null,
        //           "colSpan": null
        //         }
        //       ]
        //     },
        //     "pointsEarnRules": {
        //       "headingLable": [
        //         {
        //           "keyName": "srNo"
        //         },
        //         {
        //           "keyName": "quarterlyOfftakeTbb"
        //         },
        //         {
        //           "keyName": "quarterlyOfftakeTbr"
        //         },
        //         {
        //           "keyName": "minimumOfftakeRequired"
        //         },
        //         {
        //           "keyName": "pointPerTyreTbb"
        //         },
        //         {
        //           "keyName": "pointPerTyreTbr"
        //         },
        //         {
        //           "keyName": "pointsTbb"
        //         },
        //         {
        //           "keyName": "pointsTbr"
        //         },
        //         {
        //           "keyName": "pointsSlabJumpPoints"
        //         },
        //         {
        //           "keyName": "totalPoints"
        //         }
        //       ],
        //       "data": [
        //         {
        //           "srNo": "Example 1",
        //           "quarterlyOfftakeTbr": "100",
        //           "quarterlyOfftakeTbb": "251",
        //           "minimumOfftakeRequired": "60",
        //           "pointPerTyreTbr": "300",
        //           "pointPerTyreTbb": "175",
        //           "pointsTbr": "30000",
        //           "pointsTbb": "43925",
        //           "pointsSlabJumpPoints": "23000",
        //           "totalPoints": "96925"
        //         },
        //         {
        //           "srNo": "Example 2",
        //           "quarterlyOfftakeTbr": "55",
        //           "quarterlyOfftakeTbb": "40",
        //           "minimumOfftakeRequired": "60",
        //           "pointPerTyreTbr": "300",
        //           "pointPerTyreTbb": "175",
        //           "pointsTbr": "16500",
        //           "pointsTbb": "70000",
        //           "pointsSlabJumpPoints": "-",
        //           "totalPoints": "23500"
        //         },
        //         {
        //           "srNo": "Example 3",
        //           "quarterlyOfftakeTbr": "20",
        //           "quarterlyOfftakeTbb": "10",
        //           "minimumOfftakeRequired": "60",
        //           "pointPerTyreTbr": "300",
        //           "pointPerTyreTbb": "175",
        //           "pointsTbr": "0",
        //           "pointsTbb": "0",
        //           "pointsSlabJumpPoints": "-",
        //           "totalPoints": "0"
        //         }
        //       ]
        //     },
        //     "termsAndCondtions": {
        //       "title": "General Terms",
        //       "data": [
        //         "The enrolment to this programme is by invitation only and JK Tyre & Industries Ltd. holds sole discretion in selecting the members to be enrolled.",
        //         "This scheme is available only for the selected fleet members in the selected cities of India. Only direct purchase from JK Tyre & Industries Ltd. will be eligible for earning points in the program.",
        //         "Points or Reward of the Gift Catalogue cannot be exchanged, transferred or redeemed for cash or credit note.",
        //         "Once redemption is announced points can be redeemed for an amount equivalent to or less than the points accumulated at the time of redemption request.",
        //         "JK Tyre & Industries Ltd. dose not have obligation to reveal the value of points and rewards to the Fleet member.",
        //         "Computation of points by JK Tyre & Industries Ltd. will be final, conclusive and binding on the members and will not be called in disputed except in case of manifest, bona fide or inadvertent error",
        //         "JK Tyre & Industries Ltd. does not have any obligation to reveal the value of points and rewards to the members JK Tyre holds the decision to change the product as per the availability and price escalation.",
        //         "The terms and condition of the program are governed by the law of India.",
        //         "JK Tyre & Industries Ltd. will have the right to verify any/all sales made during the scheme period whatever way it deems fit.",
        //         "JK Tyre and Industry Ltd holds the full right to change or update the program or any term without any intimation or obligation.",
        //         "JK Tyre has appointed Walkins CRM (A product of LoMoSo Solutions Pvt Ltd) to manage the entire program including portal and mobile app."
        //       ]
        //     }
        //   },
        //   "2024-25": {
        //     "aboutTheProgram": "The JK Baadshah is a flagship Customer Relationship Program for fleet customers buying JK Truck/Bus Radial and Bias Tyres directly from the company. The program is relaunched for FY 2024-25 with an aim to reward fleet customers who are high performers and acknowledges their effort. It also simplifies the communication exchange between the fleet customers and JK Tyre. The whole motive is to build long term relationships and partnerships. JK Baadshah is the only loyalty program which is offered to the fleet customers across the industry, and today is considered as one of the biggest program.",
        //     "aboutPoints": [
        //       "There will be 6 club categories under which each member will be classified and rewarded.",
        //       "For the ease of access, this program is available on JK Baadshah web portal and mobile app where fleet can check their points, build profile, add subsidiaries and redeem points against the attractive gifts.",
        //       "Apart from Loyalty Reward, this program is a communication tool between fleets and JK Tyres and keep informing and updating fleets on various new products, customer friendly warranty policies , schemes, news alerts pertaining to the industry."
        //     ],
        //     "enrollmentToTheProgram": [],
        //     "pointsEarning": [
        //       "Fleets can earn points against their JK Tyre Truck Bias and Radial offtake as per the point structure only direct purchase from the company will be taken into consideration while calculating the points.",
        //       "Fleet club will be decided by JK Tyre as per the policy in the beginning of the financial year and will remain same for the entire financial year.",
        //       "Sales will be taken from the SAP for each fleet.",
        //       "Claim Tyres will be debited from the offtake for that month. Points will be calculated on a daily basis and slab will be calculated on quarterly basis.",
        //       "Slab jump bonus will be extra and applicable as per the quarterly slab.",
        //       "Entire point earning system is automated and points will be reflected on JK Baadshah portal and mobile App.",
        //       "To login to web portal, visit https://baadshah.jktyrecrm.in or download mobile App JK Baadshah from Google Play Store or Apple App Store. JK Tyre holds to cancel fleet points at any given point in case any discrepancy comes across.",
        //       "JK Tyre has the right to restructure the fleet clubs and points in case of any discrepancy."
        //     ],
        //     "pointStructure": [],
        //     "allCategoryPoints": {
        //       "headers": [
        //         "Club",
        //         "Minimum Quarterly Offtake",
        //         "TBB points per Tyre",
        //         "TBR points per Tyre",
        //         "Slab Jump Bonus Points"
        //       ],
        //       "points": [
        //         [
        //           "Blue Club",
        //           "30",
        //           "150",
        //           "250",
        //           "3000"
        //         ],
        //         [
        //           "Gold Club",
        //           "60",
        //           "175",
        //           "300",
        //           "5000"
        //         ],
        //         [
        //           "Diamond Club",
        //           "90",
        //           "200",
        //           "350",
        //           "11000"
        //         ],
        //         [
        //           "Platinum Club",
        //           "180",
        //           "250",
        //           "400",
        //           "23000"
        //         ],
        //         [
        //           "Chairman's Club",
        //           "360",
        //           "300",
        //           "450",
        //           "25000*"
        //         ]
        //       ],
        //       "chairmanClubNote": "*Chairman's Club Slab jump bonus points will be given on achieving min quarterly offtake in any quarter."
        //     },
        //     "fleetClub": " Gold Club",
        //     "pointsEarnRulesHeading": {
        //       "heading1": [
        //         {
        //           "keyName": "srNo",
        //           "labelName": "Sr No",
        //           "rowSpan": 2,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "quarterlyOfftake",
        //           "labelName": "Quarterly Offtake",
        //           "rowSpan": null,
        //           "colSpan": 2
        //         },
        //         {
        //           "keyName": "minimumOfftakeRequired",
        //           "labelName": "Minimum Offtake required",
        //           "rowSpan": 2,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "pointPerTyre",
        //           "labelName": "Points per Tyre",
        //           "rowSpan": null,
        //           "colSpan": 2
        //         },
        //         {
        //           "keyName": "points",
        //           "labelName": "Points",
        //           "rowSpan": null,
        //           "colSpan": 3
        //         },
        //         {
        //           "keyName": "totalPoints",
        //           "labelName": "Total Points",
        //           "rowSpan": 2,
        //           "colSpan": null
        //         }
        //       ],
        //       "heading2": [
        //         {
        //           "keyName": "quarterlyOfftakeTbb",
        //           "labelName": "TBB",
        //           "rowSpan": null,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "quarterlyOfftakeTbr",
        //           "labelName": "TBR",
        //           "rowSpan": null,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "pointPerTyreTbb",
        //           "labelName": "TBB",
        //           "rowSpan": null,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "pointPerTyreTbr",
        //           "labelName": "TBR",
        //           "rowSpan": null,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "pointsTbb",
        //           "labelName": "TBB",
        //           "rowSpan": null,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "pointsTbr",
        //           "labelName": "TBR",
        //           "rowSpan": null,
        //           "colSpan": null
        //         },
        //         {
        //           "keyName": "pointsSlabJumpPoints",
        //           "labelName": "Slab Jump Points",
        //           "rowSpan": null,
        //           "colSpan": null
        //         }
        //       ]
        //     },
        //     "pointsEarnRules": {
        //       "headingLable": [
        //         {
        //           "keyName": "srNo"
        //         },
        //         {
        //           "keyName": "quarterlyOfftakeTbb"
        //         },
        //         {
        //           "keyName": "quarterlyOfftakeTbr"
        //         },
        //         {
        //           "keyName": "minimumOfftakeRequired"
        //         },
        //         {
        //           "keyName": "pointPerTyreTbb"
        //         },
        //         {
        //           "keyName": "pointPerTyreTbr"
        //         },
        //         {
        //           "keyName": "pointsTbb"
        //         },
        //         {
        //           "keyName": "pointsTbr"
        //         },
        //         {
        //           "keyName": "pointsSlabJumpPoints"
        //         },
        //         {
        //           "keyName": "totalPoints"
        //         }
        //       ],
        //       "data": [
        //         {
        //           "srNo": "Example 1",
        //           "quarterlyOfftakeTbr": "100",
        //           "quarterlyOfftakeTbb": "251",
        //           "minimumOfftakeRequired": "60",
        //           "pointPerTyreTbr": "300",
        //           "pointPerTyreTbb": "175",
        //           "pointsTbr": "30000",
        //           "pointsTbb": "43925",
        //           "pointsSlabJumpPoints": "23000",
        //           "totalPoints": "96925"
        //         },
        //         {
        //           "srNo": "Example 2",
        //           "quarterlyOfftakeTbr": "55",
        //           "quarterlyOfftakeTbb": "40",
        //           "minimumOfftakeRequired": "60",
        //           "pointPerTyreTbr": "300",
        //           "pointPerTyreTbb": "175",
        //           "pointsTbr": "16500",
        //           "pointsTbb": "70000",
        //           "pointsSlabJumpPoints": "-",
        //           "totalPoints": "23500"
        //         },
        //         {
        //           "srNo": "Example 3",
        //           "quarterlyOfftakeTbr": "20",
        //           "quarterlyOfftakeTbb": "10",
        //           "minimumOfftakeRequired": "60",
        //           "pointPerTyreTbr": "300",
        //           "pointPerTyreTbb": "175",
        //           "pointsTbr": "0",
        //           "pointsTbb": "0",
        //           "pointsSlabJumpPoints": "-",
        //           "totalPoints": "0"
        //         }
        //       ]
        //     },
        //     "termsAndCondtions": {
        //       "title": "General Terms",
        //       "data": [
        //         "The enrolment to this programme is by invitation only and JK Tyre & Industries Ltd. holds sole discretion in selecting the members to be enrolled.",
        //         "This scheme is available only for the selected fleet members in the selected cities of India. Only direct purchase from JK Tyre & Industries Ltd. will be eligible for earning points in the program.",
        //         "Points or Reward of the Gift Catalogue cannot be exchanged, transferred or redeemed for cash or credit note.",
        //         "Once redemption is announced points can be redeemed for an amount equivalent to or less than the points accumulated at the time of redemption request.",
        //         "JK Tyre & Industries Ltd. dose not have obligation to reveal the value of points and rewards to the Fleet member.",
        //         "Computation of points by JK Tyre & Industries Ltd. will be final, conclusive and binding on the members and will not be called in disputed except in case of manifest, bona fide or inadvertent error",
        //         "JK Tyre & Industries Ltd. does not have any obligation to reveal the value of points and rewards to the members JK Tyre holds the decision to change the product as per the availability and price escalation.",
        //         "The terms and condition of the program are governed by the law of India.",
        //         "JK Tyre & Industries Ltd. will have the right to verify any/all sales made during the scheme period whatever way it deems fit.",
        //         "JK Tyre and Industry Ltd holds the full right to change or update the program or any term without any intimation or obligation.",
        //         "JK Tyre has appointed Walkins CRM (A product of LoMoSo Solutions Pvt Ltd) to manage the entire program including portal and mobile app."
        //       ]
        //     },
        //     // New dattta
        //     "revisedPolicy": {
        //       "title": "Revised Baadshah Club Points Policy – Effective FY25 (April 2024 Onwards)",
        //       "data": [
        //         "In any quarter, if a Baadshah Club fleet member is unable to achieve their minimum quarterly offtake as per their club they will be eligible for the Exception Points instead of zero points."
        //       ]
        //     },
        //     "revisedPolicyLogicForExceptionPoints": {
        //       "title": "Logic for Exception Points",
        //       "data": [
        //         "If a fleet does not meet the minimum quarterly offtake required for their current club they will be eligible for points as per the actual offtake slab aligned with a lower club."
        //       ]
        //     },
        //     "exampleOfPointCalculation": {
        //       "title": "Example of Point Calculation:",
        //       "sub_title": "Fleet Club : Chairman Club",
        //       "pointsEarnRulesHeading": {
        //         "heading1": [
        //           {
        //             "keyName": "srNo",
        //             "labelName": "Sr No",
        //             "rowSpan": 2,
        //             "colSpan": null
        //           },
        //           {
        //             "keyName": "quarterlyOfftake",
        //             "labelName": "Quarterly Offtake",
        //             "rowSpan": null,
        //             "colSpan": 2
        //           },
        //           {
        //             "keyName": "minimumOfftakeRequired",
        //             "labelName": "Minimum Offtake required",
        //             "rowSpan": 2,
        //             "colSpan": null
        //           },
        //           {
        //             "keyName": "pointPerTyre",
        //             "labelName": "Points per Tyre",
        //             "rowSpan": null,
        //             "colSpan": 2
        //           },
        //           {
        //             "keyName": "points",
        //             "labelName": "Points",
        //             "rowSpan": null,
        //             "colSpan": 3
        //           },
        //           {
        //             "keyName": "totalPoints",
        //             "labelName": "Total Points",
        //             "rowSpan": 2,
        //             "colSpan": null
        //           }
        //         ],
        //         "heading2": [
        //           {
        //             "keyName": "quarterlyOfftakeTbb",
        //             "labelName": "TBB",
        //             "rowSpan": null,
        //             "colSpan": null
        //           },
        //           {
        //             "keyName": "quarterlyOfftakeTbr",
        //             "labelName": "TBR",
        //             "rowSpan": null,
        //             "colSpan": null
        //           },
        //           {
        //             "keyName": "pointPerTyreTbb",
        //             "labelName": "TBB",
        //             "rowSpan": null,
        //             "colSpan": null
        //           },
        //           {
        //             "keyName": "pointPerTyreTbr",
        //             "labelName": "TBR",
        //             "rowSpan": null,
        //             "colSpan": null
        //           },
        //           {
        //             "keyName": "pointsTbb",
        //             "labelName": "TBB",
        //             "rowSpan": null,
        //             "colSpan": null
        //           },
        //           {
        //             "keyName": "pointsTbr",
        //             "labelName": "TBR",
        //             "rowSpan": null,
        //             "colSpan": null
        //           },
        //           {
        //             "keyName": "pointsSlabJumpPoints",
        //             "labelName": "Slab Jump Points",
        //             "rowSpan": null,
        //             "colSpan": null
        //           }
        //         ]
        //       },
        //       "pointsEarnRules": {
        //         "headingLable": [
        //           {
        //             "keyName": "srNo"
        //           },
        //           {
        //             "keyName": "quarterlyOfftakeTbb"
        //           },
        //           {
        //             "keyName": "quarterlyOfftakeTbr"
        //           },
        //           {
        //             "keyName": "minimumOfftakeRequired"
        //           },
        //           {
        //             "keyName": "pointPerTyreTbb"
        //           },
        //           {
        //             "keyName": "pointPerTyreTbr"
        //           },
        //           {
        //             "keyName": "pointsTbb"
        //           },
        //           {
        //             "keyName": "pointsTbr"
        //           },
        //           {
        //             "keyName": "pointsSlabJumpPoints"
        //           },
        //           {
        //             "keyName": "totalPoints"
        //           }
        //         ],
        //         "data": [
        //           {
        //             "srNo": "Example 1",
        //             "quarterlyOfftakeTbb": "32",
        //             "quarterlyOfftakeTbr": "107",
        //             "minimumOfftakeRequired": "360",
        //             "pointPerTyreTbb": "200",
        //             "pointPerTyreTbr": "350",
        //             "pointsTbb": "6400",
        //             "pointsTbr": "37450",
        //             "pointsSlabJumpPoints": "-",
        //             "totalPoints": "43850"
        //           },
        //           {
        //             "srNo": "Example 1",
        //             "quarterlyOfftakeTbb": "90",
        //             "quarterlyOfftakeTbr": "100",
        //             "minimumOfftakeRequired": "360",
        //             "pointPerTyreTbb": "300",
        //             "pointPerTyreTbr": "450",
        //             "pointsTbb": "27000",
        //             "pointsTbr": "45000",
        //             "pointsSlabJumpPoints": "-",
        //             "totalPoints": "72000"
        //           },
        //           {
        //             "srNo": "Example 1",
        //             "quarterlyOfftakeTbb": "25",
        //             "quarterlyOfftakeTbr": "45",
        //             "minimumOfftakeRequired": "360",
        //             "pointPerTyreTbb": "175",
        //             "pointPerTyreTbr": "300",
        //             "pointsTbb": "4375",
        //             "pointsTbr": "13500",
        //             "pointsSlabJumpPoints": "-",
        //             "totalPoints": "17875"
        //           },
        //         ]
        //       },
        //     },
        //     "illustrativeScenario": {
        //       "title": "Illustrative Scenario",
        //       "data": [
        //         "A Chairman Club fleet member with a minimum quarterly offtake target of 360 tyres lifts only 100 tyres. Under the revised policy instead of receiving zero points they will earn Exception Points based on the Diamond Club slab for that quarter. Under the previous policy, they would not have received any points for that quarter.",
        //         "This revised policy ensures continued engagement and rewards for all fleet members recognizing their business contributions even in lower offtake periods."
        //       ]
        //     }
        //   },
        //   "2025-26": {
        //     aboutTheProgram: "CRM Baadshah Program (For Fleets) – FY 2025–2026",
        //     aboutParas: [
        //       "This is effective from April 2025 onwards till further announcement or any revision.",
        //       "All Fleets who do direct business with JK Tyre under fleet management are eligible to become a member of the Baadshah program and can entails the benefits of the program.",
        //     ],
        //     aboutPoints: [],
        //     programConstruct:
        //       "The Fleets will be classified within six club categories. The categorization is based on the fleet’s tyre purchase potential and share of business with JK Tyre.",
        //     programConstructPoints: [
        //       "Chairman’s Club",
        //       "Platinum Club",
        //       "Diamond Club",
        //       "Gold Club",
        //       "Blue Club",
        //       "Starter Club",
        //     ],
        //     clubLogic:
        //       "The fleets will be assigned the clubs basis the following criteria:",
        //     clubLogicPoints: [
        //       "No. of Wheels (Potential)",
        //       "Average Off-take / Month",
        //     ],
        //     enrollmentToTheProgram: [],
        //     pointsEarning: [
        //       "All Baadshah program members (except Starter club) are eligible to earn points on their Truck tyre offtake basis the below mentioned slabs and the payout will as per the given quarterly offtake slabs irrespective of their clubs.",
        //     ],
        //     pointStructure: [],
        //     allCategoryPoints: {
        //       headers: [
        //         "Quarterly off-take (TBB+TBR)",
        //         "TBB points per Tyre",
        //         "TBR points per Tyre",
        //       ],
        //       points: [
        //         ["30-59", "150", "250"],
        //         ["60-89", "175", "300"],
        //         ["90-179", "200", "350"],
        //         ["180-359", "250", "400"],
        //         ["360 & Above", "300", "450"],
        //       ],
        //       chairmanClubNote:
        //         "New Fleets: For new fleets, minimum quarterly Offtake will be considered at a pro rata basis in the joining quarter.",
        //       salesReturnPolicy: [
        // "In the event of a sales return from any fleet after the quarter has closed, the corresponding offtake will be adjusted in the offtake figures of the previous quarter in which the sales originally occurred if the net sales in the quarter is negative this logic will be individually applied to TBR and TBB.",
        //  "Example: If a fleet purchases 100 tyres in Q1 and there is a net sale of -10 tyres in Q2. Then the actual offtake in Q1 will be adjusted to 90 tyres."
        // ]
        //     },
        //     fleetClub: "",
        //     pointsEarnRulesHeading: {
        //       heading1: [
        //         {
        //           keyName: "srNo",
        //           labelName: "Sr No",
        //           rowSpan: 2,
        //           colSpan: null,
        //         },
        //         {
        //           keyName: "quarterlyOfftake",
        //           labelName: "Quarterly Offtake",
        //           rowSpan: null,
        //           colSpan: 2,
        //         },
        //         {
        //           keyName: "minimumOfftakeRequired",
        //           labelName: "Quarterly off-Take slab (TBB+TBR)",
        //           rowSpan: 2,
        //           colSpan: null,
        //         },
        //         {
        //           keyName: "pointPerTyre",
        //           labelName: "Points per Tyre",
        //           rowSpan: null,
        //           colSpan: 2,
        //         },
        //         {
        //           keyName: "points",
        //           labelName: "Points",
        //           rowSpan: null,
        //           colSpan: 2,
        //         },
        //         {
        //           keyName: "totalPoints",
        //           labelName: "Total Points",
        //           rowSpan: 2,
        //           colSpan: null,
        //         },
        //       ],
        //       heading2: [
        //         {
        //           keyName: "quarterlyOfftakeTbb",
        //           labelName: "TBB",
        //           rowSpan: null,
        //           colSpan: null,
        //         },
        //         {
        //           keyName: "quarterlyOfftakeTbr",
        //           labelName: "TBR",
        //           rowSpan: null,
        //           colSpan: null,
        //         },
        //         {
        //           keyName: "pointPerTyreTbb",
        //           labelName: "TBB",
        //           rowSpan: null,
        //           colSpan: null,
        //         },
        //         {
        //           keyName: "pointPerTyreTbr",
        //           labelName: "TBR",
        //           rowSpan: null,
        //           colSpan: null,
        //         },
        //         {
        //           keyName: "pointsTbb",
        //           labelName: "TBB",
        //           rowSpan: null,
        //           colSpan: null,
        //         },
        //         {
        //           keyName: "pointsTbr",
        //           labelName: "TBR",
        //           rowSpan: null,
        //           colSpan: null,
        //         },
        //       ],
        //     },
        //     earningPointsProcess: {
        //       title: "Process For Earning Points:",
        //       data: [
        //         "Fleets can earn points against their JK Tyre Truck Bias and Radial offtake as per the point structure. (Only direct purchase from the company will be taken into consideration while calculating the points).",
        //         "Fleet club will be decided by JK Tyre as per the policy in the beginning of the financial year and will remain same for the entire financial year.",
        //         "Only direct sales will be taken for calculating the eligibility and benefit and following bill types are excluded from the calculation.",
        //         "YFCL, ZFCL, YFOC, ZFOC, YROP, ZROP, YRDR, ZRDR",
        //       ],
        //     },
        //     illustrativeScenario: {
        //       title: "POINTS REDEMPTION:",
        //       data: [
        //         "Club Members enrolled in the JK Baadshah program can redeem points against rewards during the redemption window. The redemption window duration and timing will be announced by Head Office and fleets can choose the rewards from the redemption list. The fleet can redeem the points against rewards and No Credit Note will be issued against the points earned by the Fleet.",
        //       ],
        //     },
        //     pointsEarnRules: {
        //       headingLable: [
        //         {
        //           keyName: "srNo",
        //         },
        //         {
        //           keyName: "quarterlyOfftakeTbb",
        //         },
        //         {
        //           keyName: "quarterlyOfftakeTbr",
        //         },
        //         {
        //           keyName: "minimumOfftakeRequired",
        //         },
        //         {
        //           keyName: "pointPerTyreTbb",
        //         },
        //         {
        //           keyName: "pointPerTyreTbr",
        //         },
        //         {
        //           keyName: "pointsTbb",
        //         },
        //         {
        //           keyName: "pointsTbr",
        //         },
        //         {
        //           keyName: "totalPoints",
        //         },
        //       ],
        //       data: [
        //         {
        //           srNo: "Example 1",
        //           quarterlyOfftakeTbr: "87",
        //           quarterlyOfftakeTbb: "100",
        //           minimumOfftakeRequired: "180-359",
        //           pointPerTyreTbr: "400",
        //           pointPerTyreTbb: "250",
        //           pointsTbr: "34800",
        //           pointsTbb: "25000",
        //           totalPoints: "59800",
        //         },
        //         {
        //           srNo: "Example 2",
        //           quarterlyOfftakeTbr: "17",
        //           quarterlyOfftakeTbb: "40",
        //           minimumOfftakeRequired: "30-59",
        //           pointPerTyreTbr: "250",
        //           pointPerTyreTbb: "150",
        //           pointsTbr: "4250",
        //           pointsTbb: "6000",
        //           totalPoints: "10250",
        //         },
        //       ],
        //     },
        //     termsAndCondtions: {
        //       title: "General Terms",
        //       data: [
        //         "The enrolment to this programme is by invitation only and JK Tyre & Industries Ltd. holds sole discretion in selecting the members to be enrolled.",
        //         "This scheme is available only for the selected fleet members in the selected cities of India. Only direct purchase from JK Tyre & Industries Ltd. will be eligible for earning points in the program.",
        //         "Points or Reward of the Gift Catalogue cannot be exchanged, transferred or redeemed for cash or credit note.",
        //         "Once redemption is announced points can be redeemed for an amount equivalent to or less than the points accumulated at the time of redemption request.",
        //         "JK Tyre & Industries Ltd. dose not have obligation to reveal the value of points and rewards to the Fleet member.",
        //         "Computation of points by JK Tyre & Industries Ltd. will be final, conclusive and binding on the members and will not be called in disputed except in case of manifest, bona fide or inadvertent error",
        //         "JK Tyre & Industries Ltd. does not have any obligation to reveal the value of points and rewards to the members JK Tyre holds the decision to change the product as per the availability and price escalation.",
        //         "The terms and condition of the program are governed by the law of India.",
        //         "JK Tyre & Industries Ltd. will have the right to verify any/all sales made during the scheme period whatever way it deems fit.",
        //         "JK Tyre and Industry Ltd holds the full right to change or update the program or any term without any intimation or obligation.",
        //         "JK Tyre has appointed Walkins CRM (A product of LoMoSo Solutions Pvt Ltd) to manage the entire program including portal and mobile app.",
        //       ],
        //     },
        //   },
        // };

        let index = this.allData.years.findIndex((y) => y.selected === true);
        let selectedYearData = this.allData.years[index];
        let aboutData = this.allData[selectedYearData.value];
        this.setState({ aboutData, selectedYearData, isLoading: false });
      }

      this.setState(prevState => {
        return { ...prevState };
      });
    } catch (error) {
      this.setState({ isLoading: false })
      console.log(error);
    }
  };

  getStripedStyle(index) {
    return { background: index % 2 === 0 ? "#f6f6f6" : "white" };
  }

  toggle(tab) {
    if (this.state.activeCategory !== tab) {
      this.setState({
        activeCategory: tab
      });
      this.scrollTo();
    }
  }
  checkUserAgent() {
    this.isMobile = false;
    const ua = navigator.userAgent;
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
        ua
      )
    ) {
      this.isMobile = true;
      return "mobile";
    } else if (/Chrome/i.test(ua)) {
      return "chrome";
    } else {
      return "other";
    }
  }

  showMore = isShow => {
    this.isShowMore = isShow;
    this.setState(prevState => {
      return { ...prevState };
    });
  };
  scrollTo() {
    var scroller = Scroll.scroller;
    scroller.scrollTo("pasanger-car-redial-wrapp", {
      duration: 1000,
      delay: 100,
      smooth: "easeInOutQuint",
      offset: -80
    });
  }

  handleInputChange = (e) => {
    e.preventDefault();
    let years = this.allData.years;
    let index = years.findIndex((y) => y.value === e.target.value);
    let selectedYearData = years[index];
    let aboutData = this.allData[selectedYearData.value];
    this.setState({ aboutData, selectedYearData });
  };

  render() {
    const { aboutData, selectedYearData, isLoading } = this.state;
    console.log("aboutDataaaa===", aboutData)
    // let arr = ["point-structure-card", "mr-2", "mb-3"];
    // let DirectIndirecttableData = [];
    return (
      <Fragment>
        {isLoading && <CustomSpinner />}
        <div className={classnames({ "padding-15px-15px-0": !this.isLogin })} id="about-program">
          <Row>
            <Col sm="9"></Col>
            <Col sm="3" className="set-right-dropdown">
              <div className="fy-label">FY</div>
              <span>
                {" "}
                {selectedYearData && (
                  <select
                    onChange={(e) => this.handleInputChange(e)}
                    value={selectedYearData.value}
                    className="form-control text-capitalize mb-1"
                  >
                    {this.allData &&
                      this.allData.years.map((y) => (
                        <option
                          value={y.value}
                          defaultChecked={y.selected}
                        // onChange={() => this.handleInputChange(y)}
                        >
                          {y.key}
                        </option>
                      ))}
                  </select>
                )}
              </span>
            </Col>
          </Row>
          <Col md="12" className="mb-3" style={{ paddingLeft: "0" }}>
            <div className="About-the-Program mb-3">About the Program</div>
            {!this.isMobile && aboutData && (
              <div className="The-Advantage-progra">
                {aboutData.aboutTheProgram}
                {/* Conditional rendering for 2025-26 data */}
                {aboutData.aboutParas &&
                  aboutData.aboutParas.length > 0 &&
                  aboutData.aboutParas.map((item) => {
                    return <p>{item}</p>;
                  })}
                
                <div>
                  <ul className="Enrollment-ul">
                    {aboutData.aboutPoints.map(item => (
                      <li className="enroll-li">{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
            {/* Conditional rendering for 2025-26 data */}
            {!this.isMobile && aboutData && aboutData.programConstruct && (
              <div>
                <div className="About-the-Program mb-3">Program Construct</div>
                <div>
                  <p>{aboutData.programConstruct}</p>
                  <ul className="Enrollment-ul" style={{ marginLeft: "1rem" }}>
                    {aboutData.programConstructPoints &&
                      aboutData.programConstructPoints.length > 0 &&
                      aboutData.programConstructPoints.map((item) => (
                        <li className="enroll-li">{item}</li>
                      ))}
                  </ul>
                </div>
              </div>
            )}
            {/* Conditional rendering for 2025-26 data */}
            {!this.isMobile && aboutData && aboutData.clubLogic && (
              <div>
                <div className="About-the-Program mb-3">Club Logic</div>
                <div style={{ marginLeft: "1rem" }}>
                  <p>{aboutData.clubLogic}</p>
                  <ul className="Enrollment-ul" style={{ marginLeft: "1rem" }}>
                    {aboutData.clubLogicPoints.map((item) => (
                      <li className="enroll-li">{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
            {this.isMobile && aboutData && (
              <div>
                {!this.state.showTextAbout && (
                  <div className="The-Advantage-progra">
                    {aboutData.aboutTheProgram.substring(0, 65)}...
                    <span
                      className="show-more-copy"
                      onClick={() =>
                        this.setState({
                          showTextAbout: !this.state.showTextAbout
                        })
                      }
                      style={{ color: "#fdbb1f" }}
                    >
                      See more
                    </span>
                  </div>
                )}
                <Collapse isOpen={this.state.showTextAbout}>
                  <div className="The-Advantage-progra">
                    {aboutData.aboutTheProgram}
                    <div>
                      <ul className="Enrollment-ul">
                        {aboutData.aboutPoints.map(item => (
                          <li className="enroll-li">{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <span
                    className="show-more-copy"
                    onClick={() =>
                      this.setState({
                        showTextAbout: !this.state.showTextAbout
                      })
                    }
                    style={{ color: "#fdbb1f" }}
                  >
                    See Less
                  </span>
                </Collapse>
              </div>
            )}
          </Col>
          <hr style={{ border: "solid 1px #e0e2e4" }} />
          <div>
            {aboutData && aboutData.enrollmentToTheProgram.length > 0 && <Col md="12" style={{ paddingLeft: "0" }}>
              <div className="About-the-Program mb-3">
                Enrollment to the Program
              </div>
              {!this.isMobile && aboutData && (
                <div>
                  <ul className="Enrollment-ul">
                    {aboutData.enrollmentToTheProgram.map &&
                      aboutData.enrollmentToTheProgram.map(item => (
                        <li className="enroll-li">{item}</li>
                      ))}
                  </ul>
                </div>
              )}
              {this.isMobile && aboutData && (
                <div>
                  {!this.state.showTextEnroll && (
                    <ul className="Enrollment-ul">
                      {aboutData.enrollmentToTheProgram.map(
                        (item, i) =>
                          i === 0 && (
                            <li className="enroll-li">
                              {item.substring(0, 60)}...
                              <span
                                className="show-more-copy"
                                onClick={() =>
                                  this.setState({
                                    showTextEnroll: !this.state.showTextEnroll
                                  })
                                }
                                style={{ color: "#fdbb1f" }}
                              >
                                Show more
                              </span>
                            </li>
                          )
                      )}
                    </ul>
                  )}
                  <Collapse isOpen={this.state.showTextEnroll}>
                    <ul className="Enrollment-ul">
                      {aboutData.enrollmentToTheProgram.map((item, i) => (
                        <li className="enroll-li">
                          {item}
                          {i ===
                            aboutData.enrollmentToTheProgram.length - 1 && (
                              <span
                                className="show-more-copy"
                                onClick={() =>
                                  this.setState({
                                    showTextEnroll: !this.state.showTextEnroll
                                  })
                                }
                                style={{ color: "#fdbb1f" }}
                              >
                                Show Less
                              </span>
                            )}
                        </li>
                      ))}
                    </ul>
                  </Collapse>
                </div>
              )}
            </Col>}
            <Col md="12" style={{ paddingLeft: "0" }}>
              <div className="About-the-Program mb-3">Points Earning</div>
              {!this.isMobile && aboutData && (
                <div>
                  <ul className="Enrollment-ul">
                    {aboutData.pointsEarning &&
                      aboutData.pointsEarning.map(item => (
                        <li className="enroll-li">{item}</li>
                      ))}
                  </ul>
                </div>
              )}
              {this.isMobile && aboutData && (
                <div>
                  {!this.state.showTextPointsEarn && (
                    <ul className="Enrollment-ul">
                      {aboutData.pointsEarning.map(
                        (item, i) =>
                          i === 0 && (
                            <li className="enroll-li">
                              {item.substring(0, 60)}...
                              <span
                                className="show-more-copy"
                                onClick={() =>
                                  this.setState({
                                    showTextPointsEarn: !this.state
                                      .showTextPointsEarn
                                  })
                                }
                                style={{ color: "#fdbb1f" }}
                              >
                                Show more
                              </span>
                            </li>
                          )
                      )}
                    </ul>
                  )}
                  <Collapse isOpen={this.state.showTextPointsEarn}>
                    <ul className="Enrollment-ul">
                      {aboutData.pointsEarning &&
                        aboutData.pointsEarning.map((item, i) => (
                          <li className="enroll-li">
                            {item}{" "}
                            {i === aboutData.pointsEarning.length - 1 && (
                              <span
                                className="show-more-copy"
                                onClick={() =>
                                  this.setState({
                                    showTextPointsEarn: !this.state
                                      .showTextPointsEarn
                                  })
                                }
                                style={{ color: "#fdbb1f" }}
                              >
                                Show Less
                              </span>
                            )}
                          </li>
                        ))}
                    </ul>
                  </Collapse>
                </div>
              )}
            </Col>
            <Col md='12'
              className="About-the-Program mb-3"
              style={{ marginLeft: "-10px" }}
            >
              {aboutData && aboutData.pointsEarningStructure}
            </Col>
            <Col md="12">
              <Row
                className="point-structure-wrapp"
              // style={{ flexWrap: "nowrap" }}
              >
                {aboutData &&
                  aboutData.pointStructure.map((item, i) => (
                    <Col
                      className={classnames(
                        // {
                        //   "mr-4":
                        //     !this.isMobile &&
                        //     i !== aboutData.pointStructure.length - 1
                        // },
                        "program-cat-card d-flex-row mb-3"
                      )}
                    >
                      <div className="d-flex-row">
                        <img src={item.image} className="program-cat-img" alt="program-cat-img" />
                      </div>
                      <div className="program-cat-lbl-wrapp">
                        <span className="program-cat-lbl mb-2">
                          {item.type}
                        </span>
                        <span className="program-cat-points">
                          {item.pointsRange[0]}
                        </span>
                      </div>
                    </Col>
                  ))}
              </Row>
            </Col>
            <Col
              lg="12"
              className="pasanger-car-redial-col"
              style={{ paddingLeft: "0", paddingRight: "0" }}
            >
              {/* <div className="pasanger-car-redial-card mr-xl-n4"> */}
              <div className="pasanger-car-redial-card" style={{ padding: '20px 30px' }}>
                <div
                  // className="pasanger-car-redial-wrapp"
                  id="pasanger-car-redial-wrapp"
                >
                  <div className='table-responsive pointsEarnTable d-block'>
                    <Table bordered className="mb-0">
                      {aboutData && (
                        <thead>
                          <tr style={{ ...this.getStripedStyle(0) }}>
                            {aboutData.allCategoryPoints.headers.map(item => (
                              <th>
                                {item}
                              </th>
                            ))}
                          </tr>
                        </thead>
                      )}
                      {aboutData && (
                        <tbody>
                          {aboutData.allCategoryPoints.points.map((row, i) => (
                            <tr
                              key={i + 1}
                              style={{ ...this.getStripedStyle(i + 1) }}
                            >
                              {row.map((item, j) => (
                                <td>
                                  {item}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      )}
                    </Table>
                  </div>
                    {aboutData && aboutData.allCategoryPoints.chairmanClubNote ?
                      <div className="mt-2">{aboutData.allCategoryPoints.chairmanClubNote.startsWith(
                        "New Fleets"
                      ) ? (
                        <span>
                          <strong>
                            {
                              aboutData.allCategoryPoints.chairmanClubNote.split(
                                ":"
                              )[0]
                            }
                          </strong>
                          :{" "}
                          {
                            aboutData.allCategoryPoints.chairmanClubNote.split(
                              ":"
                            )[1]
                          }
                          <p></p>
                            {aboutData.allCategoryPoints && aboutData.allCategoryPoints.salesReturnPolicy && aboutData.allCategoryPoints.salesReturnPolicy.length > 0 && (
                              <>
                                <strong>Sales Return Policy</strong>
                                <p>
                                  {aboutData.allCategoryPoints.salesReturnPolicy[0]}
                                </p>
                                <p>
                                  <strong>
                                    {
                                    aboutData.allCategoryPoints.salesReturnPolicy[1].split(":")[0]
                                    }
                                  </strong>
                                  :{" "}
                                  {
                                    aboutData.allCategoryPoints.salesReturnPolicy[1].split(":")[1]}
                                </p>
                              </>
                            )}
                        </span>
                      ) : (
                        <span>
                          Note: {aboutData.allCategoryPoints.chairmanClubNote}
                        </span>
                      )}
                      {/* Note: {aboutData.allCategoryPoints.chairmanClubNote} */}</div>
                    : ''}
                  {/* <br /> */}
                </div>
              </div>
            </Col>
            <div>
              <div className="Total-Members-Fleet margin-top-25 mb-2">
                Example on point earning{" "}
              </div>
              {aboutData && aboutData.fleetClub &&
                <div className="mb-2">
                  <b>Fleet Club :</b> {aboutData.fleetClub}
                </div>
              }
              <Card>
                <CardBody style={{ paddingLeft: '30px', paddingRight: '30px', paddingBottom: '20px' }}>
                  {/* {this.state.isLoaderDD && <CustomSpinner />} */}
                  <Row>
                    {/* <Col xl="12" xs="12" md="12" className="card-header-count">
                <span>Total Members(Fleets) of JK Baadshah Programme - 1,750</span>
              </Col> */}

                    <Col xl="12" xs="12" md="12">
                      <div className='table-responsive pointsEarnTable d-block'>
                        <Table bordered className=" m-0">
                          <thead>
                            <tr style={{ backgroundColor: "#f1f1f1" }}>
                              {aboutData && aboutData.pointsEarnRulesHeading && aboutData.pointsEarnRulesHeading.heading1 && aboutData.pointsEarnRulesHeading.heading1.length > 0 && aboutData.pointsEarnRulesHeading.heading1.map((item, index) => {
                                return (
                                  <th colSpan={item.colSpan} rowSpan={item.rowSpan} key={index}>{item.labelName}</th>
                                )
                              })

                              }
                            </tr>
                            <tr style={{ backgroundColor: "#f1f1f1" }}>
                              {aboutData && aboutData.pointsEarnRulesHeading && aboutData.pointsEarnRulesHeading.heading2 && aboutData.pointsEarnRulesHeading.heading2.length > 0 && aboutData.pointsEarnRulesHeading.heading2.map((item, index) => {
                                return (
                                  <th colSpan={item.colSpan} rowSpan={item.rowSpan} key={index}>{item.labelName}</th>
                                )
                              })

                              }
                            </tr>
                          </thead>
                          <tbody>
                            {aboutData && aboutData.pointsEarnRules && aboutData.pointsEarnRules.data && aboutData.pointsEarnRules.headingLable && aboutData.pointsEarnRules.data.length > 0 && aboutData.pointsEarnRules.data.map((item, index) => {
                              return (
                                <tr key={index}>
                                  {aboutData.pointsEarnRules.headingLable.map((label) => (
                                    <td key={label.keyName}>{item[label.keyName]}</td>
                                  ))}
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </div>
          </div>

          {aboutData && aboutData.revisedPolicy && aboutData.revisedPolicy.title && (
            <div className="my-3">
              <div className="About-the-Program">{aboutData.revisedPolicy.title}</div>
              {aboutData.revisedPolicy.data && Array.isArray(aboutData.revisedPolicy.data) && aboutData.revisedPolicy.data.length > 0 && (
                <div className="mt-3">
                  <ul className="Enrollment-ul">
                    {aboutData.revisedPolicy.data.map(item => (
                      <li className="enroll-li">{item}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}

          {aboutData && aboutData.revisedPolicyLogicForExceptionPoints && aboutData.revisedPolicyLogicForExceptionPoints.title && (
            <>
              <div className="Total-Members-Fleet margin-top-25 mt-3">{aboutData.revisedPolicyLogicForExceptionPoints.title}</div>
              {aboutData.revisedPolicyLogicForExceptionPoints.data && Array.isArray(aboutData.revisedPolicyLogicForExceptionPoints.data) && aboutData.revisedPolicyLogicForExceptionPoints.data.length > 0 && (
                <div className="mt-0">
                  <ul className="Enrollment-ul mt-0">
                    {aboutData.revisedPolicyLogicForExceptionPoints.data.map(item => (
                      <li className="enroll-li">{item}</li>
                    ))}
                  </ul>
                </div>
              )}
            </>
          )}
          {aboutData && aboutData.exampleOfPointCalculation && aboutData.exampleOfPointCalculation.title && (
            <div>
              <div className="Total-Members-Fleet margin-top-25 mb-2">
                {aboutData.exampleOfPointCalculation.title}
              </div>
              {aboutData.exampleOfPointCalculation.sub_title &&
                <div className="mb-2">
                  <b>{aboutData.exampleOfPointCalculation.sub_title}</b>
                </div>
              }
              <Card>
                <CardBody style={{ paddingLeft: '30px', paddingRight: '30px', paddingBottom: '20px' }}>
                  <Row>
                    <Col xl="12" xs="12" md="12">
                      <div className='table-responsive pointsEarnTable d-block'>
                        <Table bordered className=" m-0">
                          <thead>
                            <tr style={{ backgroundColor: "#f1f1f1" }}>
                              {aboutData.exampleOfPointCalculation.pointsEarnRulesHeading && aboutData.exampleOfPointCalculation.pointsEarnRulesHeading.heading1 && aboutData.exampleOfPointCalculation.pointsEarnRulesHeading.heading1.length > 0 && aboutData.exampleOfPointCalculation.pointsEarnRulesHeading.heading1.map((item, index) => {
                                return (
                                  <th colSpan={item.colSpan} rowSpan={item.rowSpan} key={index}>{item.labelName}</th>
                                );
                              })

                              }
                            </tr>
                            <tr style={{ backgroundColor: "#f1f1f1" }}>
                              {aboutData.exampleOfPointCalculation && aboutData.exampleOfPointCalculation.pointsEarnRulesHeading && aboutData.exampleOfPointCalculation.pointsEarnRulesHeading.heading2 && aboutData.exampleOfPointCalculation.pointsEarnRulesHeading.heading2.length > 0 && aboutData.exampleOfPointCalculation.pointsEarnRulesHeading.heading2.map((item, index) => {
                                return (
                                  <th colSpan={item.colSpan} rowSpan={item.rowSpan} key={index}>{item.labelName}</th>
                                );
                              })

                              }
                            </tr>
                          </thead>
                          <tbody>
                            {aboutData.exampleOfPointCalculation && aboutData.exampleOfPointCalculation.pointsEarnRules && aboutData.exampleOfPointCalculation.pointsEarnRules.data && aboutData.exampleOfPointCalculation.pointsEarnRules.headingLable && aboutData.exampleOfPointCalculation.pointsEarnRules.data.length > 0 && aboutData.exampleOfPointCalculation.pointsEarnRules.data.map((item, index) => {
                              return (
                                <tr key={index}>
                                  {aboutData.exampleOfPointCalculation.pointsEarnRules.headingLable.map((label) => (
                                    <td key={label.keyName}>{item[label.keyName]}</td>
                                  ))}
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </div>
          )}
          {/* Conditional rendering for 2025-26 data */}
          {aboutData &&
            aboutData.earningPointsProcess &&
            aboutData.earningPointsProcess.title && (
              <div>
                <div className="Total-Members-Fleet margin-top-25 mb-2">
                  {aboutData.earningPointsProcess.title}
                </div>
                {aboutData.earningPointsProcess.data &&
                  Array.isArray(aboutData.earningPointsProcess.data) &&
                  aboutData.earningPointsProcess.data.length > 0 && (
                    <div className="mt-0">
                      <ul className="Enrollment-ul mt-0">
                        {aboutData.earningPointsProcess.data.map((item) => (
                          <li className="enroll-li">{item}</li>
                        ))}
                      </ul>
                    </div>
                  )}
              </div>
          )}
          {aboutData && aboutData.illustrativeScenario && aboutData.illustrativeScenario.title && (
            <>
              <div className="Total-Members-Fleet margin-top-25 mt-3">{aboutData.illustrativeScenario.title}</div>
              {aboutData.illustrativeScenario.data && Array.isArray(aboutData.illustrativeScenario.data) && aboutData.illustrativeScenario.data.length > 0 && (
                <div className="mt-0">
                  <ul className="Enrollment-ul mt-0">
                    {aboutData.illustrativeScenario.data.map(item => (
                      <li className="enroll-li">{item}</li>
                    ))}
                  </ul>
                </div>
              )}
            </>
          )}

          <Col md="12" style={{ paddingLeft: "0" }} className="margin-top-25">
            <div className="About-the-Program mb-3">Terms And Conditions</div>
            {!this.isMobile && aboutData && (
              <div>
                <ul className="Enrollment-ul">
                  {aboutData.termsAndCondtions.data &&
                    aboutData.termsAndCondtions.data.map(item => (
                      <li className="enroll-li">{item}</li>
                    ))}
                </ul>
              </div>
            )}
            {this.isMobile && aboutData && (
              <div>
                {!this.state.showTermsAndConditions && (
                  <ul className="Enrollment-ul">
                    {aboutData.termsAndCondtions.data.map(
                      (item, i) =>
                        i === 0 && (
                          <li className="enroll-li">
                            {item.substring(0, 60)}...
                            <span
                              className="show-more-copy"
                              onClick={() =>
                                this.setState({
                                  showTermsAndConditions: !this.state
                                    .showTermsAndConditions
                                })
                              }
                              style={{ color: "#fdbb1f" }}
                            >
                              Show more
                            </span>
                          </li>
                        )
                    )}
                  </ul>
                )}
                <Collapse isOpen={this.state.showTermsAndConditions}>
                  <ul className="Enrollment-ul">
                    {aboutData.termsAndCondtions.data.map((item, i) => (
                      <li className="enroll-li">
                        {item}
                        {i === aboutData.termsAndCondtions.data.length - 1 && (
                          <span
                            className="show-more-copy"
                            onClick={() =>
                              this.setState({
                                showTermsAndConditions: !this.state
                                  .showTermsAndConditions
                              })
                            }
                            style={{ color: "#fdbb1f" }}
                          >
                            Show Less
                          </span>
                        )}
                      </li>
                    ))}
                  </ul>
                </Collapse>
              </div>
            )}
          </Col>
        </div>
      </Fragment>
    );
  }
}
